import { Form } from 'antd';
import { useDistributionCostFiltersStore } from 'shared/stores/use-distribution-cost-filters';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { DataRangeFormPicker } from 'components/common/data-range-form-picker';
import { DistributionAreaFormSelect } from 'components/common/distribution-area-form-select';
import styles from './distribution-cost-filters.module.scss';

export const DistributionCostFilters = () => {
  const { filters, setFilters } = useDistributionCostFiltersStore();
  const [form] = Form.useForm();

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  return (
    <Form form={form} name='distribution-cost-filter' layout='vertical' initialValues={filters} className={styles.form}>
      <DistributionAreaFormSelect
        name='distributionSlug'
        label='Distribution location'
        className={styles.location}
        allowClear={false}
        onChange={handleSuccess}
      />
      <DataRangeFormPicker name='date' label='Date range' picker='month' handleSuccess={handleSuccess} isRequired />
    </Form>
  );
};
